export const ACTIONS = {
    SET_ACCEPT_MODAL: "SET_ACCEPT_MODAL",
    SET_REJECT_MODAL: "SET_REJECT_MODAL",
    SET_LOADING_ACCEPT: "SET_LOADING_ACCEPT",
    SET_LOADING_REJECT: "SET_LOADING_REJECT",
};

export const initialState = {
    isAccept: false,
    isReject: false,
    loadingAccept: false,
    loadingReject: false,
};

export function orderReducer(state: typeof initialState, action: { type: string; payload?: any }) {
    switch (action.type) {
        case ACTIONS.SET_ACCEPT_MODAL:
            return { ...state, isAccept: action.payload };
        case ACTIONS.SET_REJECT_MODAL:
            return { ...state, isReject: action.payload };
        case ACTIONS.SET_LOADING_ACCEPT:
            return { ...state, loadingAccept: action.payload };
        case ACTIONS.SET_LOADING_REJECT:
            return { ...state, loadingReject: action.payload };
        default:
            return state;
    }
}
